import React from 'react'

import { SkeletonText, SkeletonButton, SpookySkeleton } from '@offerzen/pinata'

import styles from './styles'

const SkeletonCitizenshipStatus = () => (
  <SpookySkeleton>
    <SkeletonText size="medium" className={styles.defaultMargin} width={198} />

    <SkeletonText className={styles.largeMargin} width={420} />

    <SkeletonText className={styles.defaultMargin} size="large" width={500} />

    <SkeletonText className={styles.defaultMargin} width={230} />

    <SkeletonText className={styles.defaultMargin} width={460} />

    <SkeletonText className={styles.defaultMargin} width={460} />

    <SkeletonText className={styles.defaultMargin} size="large" width={187} />

    <div className={styles.buttonWrapper}>
      <SkeletonButton />
      <SkeletonButton />
    </div>
  </SpookySkeleton>
)

export default SkeletonCitizenshipStatus
